// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__NrUii","title":"ClientReferral_title__tzc7-","itemText":"ClientReferral_itemText__1uYJL"};